import React, {Fragment, ReactNode} from 'react';
import classNames from 'classnames';
import Button from "../form/Button";
import PropTypes from "prop-types";
import {connectAdvanced} from "src/store";
import {bindActionCreators} from "redux";
import {setBoxState} from "../../actions";
import {store} from "src/store";

type BoxProps = {
    width?: any,
    collapsed?: boolean,
    theme?: string,
    header?: any,
    actions?: any,
    body?: any,
    footer?: any,
    boxid?: string,
    children?: ReactNode[]|ReactNode|string
}

type BoxCompProps = BoxProps&{setBoxState: (boxid: string, state: any) => void};

type BoxCompState = {collapsed: boolean};

class DefaultBox extends React.Component<BoxCompProps, BoxCompState> {

    protected el: any;

    static propTypes = {
        width: PropTypes.any,
        collapsed: PropTypes.bool,
        theme: PropTypes.string,
        header: PropTypes.any,
        actions: PropTypes.any,
        body: PropTypes.any,
		footer: PropTypes.any,
		boxid: PropTypes.string,
    }

    setPersistenceState = (state: any, cb?: Function) => {
        this.setState(state, () => {
            if (this.props.boxid) {
                this.props.setBoxState(this.props.boxid, this.state);
            }
            cb && cb();
        });
    }

	constructor(props: BoxCompProps) {
		super(props);
        const stored = props.boxid ? store.getState().boxes[props.boxid] : null;
		this.state = {
            collapsed: stored ? stored.collapsed : this.props.collapsed
        };
	}

	componentDidUpdate(prevProps: BoxCompProps, prevState: BoxCompState, prevContext: any) {
		if(prevProps.collapsed !== this.props.collapsed) {
			this.setPersistenceState({
				collapsed: this.props.collapsed
			});
		}
	}

    toggleCollapse = () => {
        if(this.state.collapsed !== undefined) {
            this.setPersistenceState({
                collapsed: !this.state.collapsed
            })
        }
	}

	focus = () => {
		this.el.focus();
	}

	hide = () => {

	}

	render() {
		return (
            <div
                ref={(el) => this.el = el}
                /*tabIndex={0}*/
                className={classNames("box box-"+(this.props.theme || "default"), {
                    "collapsed-box": this.state.collapsed === true
                })}
            >
                {
                    (this.props.header || this.state.collapsed !== undefined || this.props.actions) &&
                    <div
                        className={classNames("box-header with-border", {"clickable": !this.props.actions && this.state.collapsed !== undefined})}
                        onClick={!this.props.actions && this.state.collapsed !== undefined ? this.toggleCollapse : null}
                    >
                        {this.props.header ? this.props.header : <Fragment>&nbsp;</Fragment>}
                        {(this.state.collapsed !== undefined || this.props.actions) && <div className="box-tools pull-right">
                            {!!this.props.actions && <div className="box-actions">{this.props.actions}</div>}
                            {this.state.collapsed !== undefined && <Button onClick={this.toggleCollapse} type="button" className="btn btn-box-tool" data-widget="collapse" icon={{lib: "fa", name: classNames({"minus": !this.state.collapsed, "plus": this.state.collapsed})}} />}
                        </div>}
                    </div>
                }
                <div className="box-body">
                    {this.props.body || this.props.children}
                </div>
                {
                    this.props.footer && ((Array.isArray(this.props.footer) && !!this.props.footer.length) || !Array.isArray(this.props.footer)) &&
                    <div className="box-footer">
                        {this.props.footer}
                    </div>
                }
            </div>
		);
	}
}

const Component = connectAdvanced((dispatch: any) => {
    return (store: any, nextOwnProps: any) => {
        const actions = bindActionCreators({setBoxState}, dispatch);
        return {
            ...nextOwnProps,
            ...actions
        }
    }
},{forwardRef: true})(DefaultBox);

export default React.forwardRef((props: BoxProps, ref) => {
    return <Component ref={ref} {...props}/>;
})